import { Image, ImageProps } from 'theme-ui'

const Dyson = (props: ImageProps) => {
  return <Image width={16} src="/imgs/dyson.png" {...props} />
}
export default Dyson
